import { IFilter } from './AdvancedFilters.types'

export const getAccordionProps = (
  { uid, title }: Pick<IFilter, 'uid' | 'title'>,
  currentAccordion: string | boolean,
  onChange: ({ panel }: { panel: string }) => void
) => {
  return {
    title,
    id: uid,
    expanded: currentAccordion === uid,
    onChange
  }
}
